import { useState } from "react";
import { ScrollText } from "lucide-react";
import { usePoll } from "@/lib/usePoll";
import { dt } from "@/lib/api";
import { Panel, PageTitle, Empty } from "@/components/common";

const LEVELS = [["", "All"], ["info", "Info"], ["warn", "Warn"], ["risk", "Risk"], ["risk_alert", "Risk alert"], ["trade", "Trade"], ["emergency", "Emergency"], ["error", "Error"]];
const COLOR = { info: "text-zinc-400", warn: "text-amber-400", risk: "text-orange-400", risk_alert: "text-orange-400", trade: "text-emerald-400", emergency: "text-red-400", error: "text-red-400" };

export default function Audit() {
  const [lv, setLv] = useState("");
  const { data } = usePoll(`/audit${lv ? `?level=${lv}` : ""}`, 5000, [lv]);
  return (
    <div>
      <PageTitle title="Audit Log" sub="Immutable record of decisions, risk vetoes, executions, settings changes, emergency events and reconciliations." />
      <Panel title="Events" icon={ScrollText} testid="audit-log"
        right={<div className="flex flex-wrap gap-1">{LEVELS.map(([v, l]) => <button key={l} data-testid={`audit-filter-${l.toLowerCase().replace(" ", "-")}`} onClick={() => setLv(v)} className={`font-mono text-[10px] px-2 py-1 rounded ${lv === v ? "bg-[#F7931A] text-black" : "text-zinc-400 hover:bg-zinc-800"}`}>{l}</button>)}</div>}>
        {!data?.length ? <Empty>No events.</Empty> : (
          <div className="bg-[#090A0F] rounded-md p-3 max-h-[70vh] overflow-auto space-y-1">
            {data.map((e) => (
              <div key={e.id} className="font-mono text-[11px] leading-relaxed flex gap-3">
                <span className="text-zinc-600 whitespace-nowrap">{dt(e.ts)}</span>
                <span className={`uppercase w-20 shrink-0 ${COLOR[e.level] || "text-zinc-400"}`}>{e.level}</span>
                <span className="text-zinc-500 w-20 shrink-0">{e.category}</span>
                <span className="text-zinc-300">{e.message}</span>
              </div>))}
          </div>)}
      </Panel>
    </div>
  );
}
